<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TITLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ frame0.boardTitle }}
            </div>
          </div>
        </div>
        <div class="row">
          <div
            v-if="isCategoryGroupExist"
            class="col-xs-1"
          >
            <sui-input-label
              :label="$t('MSG_TXT_CATG')"
              :vertical="false"
            />
          </div>
          <div
            v-if="isCategoryGroupExist"
            class="col-xs-5"
          >
            <div class="comm_label">
              {{ frame0.bbsCategoryItemNm }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_USR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              <cmp-user-name-link
                :pageId="this.$options.name"
                :displayType="'1'"
                :displayLanguageId="displayLanguageId"
                :knoxId="knoxId"
                :loginId="loginId"
                :userName="userName"
                :userGlobalName="userGlobalName"
                :departmentName="departmentName"
                :departmentEnglishName="departmentEnglishName"
                :type="'link'"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_DTM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.firstRegistrationDTM }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_VIEW_CNT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.qnaNoticeObjSearchedContent }}
            </div>
          </div>
        </div>
      </div>
      <div class="mrB10" />
      <sui-web-editor
        ref="myEditor"
        :isViewer="true"
        @loaded="getQNAInfoByPostId"
      />
      <div class="mrB10" />
      <cmp-file-attacher
        ref="fileAttacher"
        :pageId="this.$options.name"
        :showAddDeleteBtn="false"
        :showUpDownArrowBtn="false"
        :showDDRegion="false"
        :attachGroupId="'ATG_CLB_BBS_COMMON'"
        :attachDocumentId="attachDocumentId"
        :customAttachRestrictionSize="attachRestrictSize"
      />
      <div class="mrB15" />
      <div
        v-if="answerUseYn === 'Y'"
        class="comment_wrap"
      >
        <ul class="comment_list">
          <li
            v-for="answer in postAnswers"
            :key="answer.answerId"
          >
            <sui-tooltip-menu
              v-if="answer.parentAnswerId==='' && isSameAuthorOrBBSADMIN(answer.knoxId) && answer.answerId!==''
                && !answer.editable && answer.deleteYn === 'N'"
              class="fl_r"
              :menu-list="[
                { label: $t('MSG_BTN_MDFC'), key: `MOD_${answer.answerId}` },
                { label: $t('MSG_BTN_DEL'), key: `DEL_${answer.answerId}` },
              ]"
              @input="onClickTooltip"
            >
              Tooltip Menu
            </sui-tooltip-menu>
            <a
              v-if="answer.parentAnswerId===''"
              class="comment_nick"
            >
              <cmp-user-name-link
                :pageId="contextPageId"
                :displayType="'1'"
                :displayLanguageId="answer.displayLanguageId"
                :userId="answer.firstRegistrationUserId"
                :loginId="answer.firstRegistrationLoginId"
                :userName="answer.userName"
                :userGlobalName="answer.userGlobalName"
                :departmentName="answer.departmentName"
                :departmentEnglishName="answer.departmentEnglishName"
                :type="'link'"
              />
            </a>
            <!-- 신규 등록 -->
            <div
              v-if="answer.answerId===''"
              class="mrT10"
            />
            <textarea
              v-if="answer.parentAnswerId==='' && (answer.answerId==='' || answer.editable)"
              v-model="answer.answerContent"
            />
            <!-- 기존 조회 -->
            <div
              v-if="answer.answerId!=='' && answer.parentAnswerId==='' && !answer.editable"
              class="comm_label"
            >
              {{ answer.answerContent }}
            </div>
            <div
              v-if="answer.answerId!=='' && answer.parentAnswerId===''"
              class="comment_date"
            >
              {{ answer.firstRegistrationDTM }}
            </div>
            <div v-if="answer.parentAnswerId===''" class="comment_wrapR">
              <sui-button
                v-if="answer.answerId!=='' && !answer.editable && answer.deleteYn==='N'"
                type="button"
                class="btn_innerTbl_border"
                @click="onClickReply(answer.answerId, answer.addReplyFlag)"
              >
                {{ answer.addReplyFlag ? $t('MSG_BTN_CANCEL_COMMENT') : $t('MSG_BTN_COMMENT') }}
              </sui-button>
              <!-- 신규 등록 -->
              <sui-button
                v-if="answer.answerId===''"
                type="button"
                class="btn_innerTbl_border"
                @click="registReply(answer.answerContent, '')"
              >
                {{ $t('MSG_BTN_RGST') }}
              </sui-button>
              <!-- 수정 -->
              <sui-button
                v-if="answer.answerId!=='' && answer.editable"
                type="button"
                class="btn_innerTbl_border"
                @click="onClickModifyCancelReply(answer.answerId)"
              >
                {{ $t('MSG_BTN_CANCEL') }}
              </sui-button>
              <sui-button
                v-if="answer.answerId!=='' && answer.editable"
                type="button"
                class="btn_innerTbl_border"
                @click="modifyReply(answer.answerId, answer.answerContent)"
              >
                {{ $t('MSG_BTN_RGST') }}
              </sui-button>
            </div>
            <!-- 댓글 클릭 시 -->
            <div
              v-if="answer.addReplyFlag && answer.parentAnswerId===''"
              class="mrB10"
            />
            <span
              v-if="answer.addReplyFlag && answer.parentAnswerId===''"
              class="ico_reply"
            />
            <div
              v-if="answer.addReplyFlag && answer.parentAnswerId===''"
              class="comment_write reply"
            >
              <cmp-user-name-link
                :pageId="contextPageId"
                :displayType="'1'"
                :displayLanguageId="sessionInfo.displayLangId"
                :userId="sessionInfo.userId"
                :loginId="sessionInfo.loginId"
                :userName="sessionInfo.userName"
                :userGlobalName="sessionInfo.userGlobalName"
                :departmentName="sessionInfo.departmentName"
                :departmentEnglishName="sessionInfo.departmentEnglishName"
                :type="'link'"
              />
              <div class="mrT10" />
              <textarea v-model="answer.childAnswerContent" />
              <div class="comment_wrapR">
                <sui-button
                  type="button"
                  class="btn_innerTbl_border"
                  @click="registReply(answer.childAnswerContent, answer.answerId)"
                >
                  {{ $t('MSG_BTN_RGST') }}
                </sui-button>
              </div>
            </div>
            <!-- 대댓글 형식 -->
            <span v-if="answer.parentAnswerId!==''" class="ico_reply" />
            <div v-if="answer.parentAnswerId!==''" class="comment_reply">
              <sui-tooltip-menu
                v-if="isSameAuthorOrBBSADMIN(answer.knoxId) && answer.answerId!==''
                  && !answer.editable && answer.deleteYn === 'N'"
                class="fl_r"
                :menu-list="[
                  { label: $t('MSG_BTN_MDFC'), key: `MOD_${answer.answerId}` },
                  { label: $t('MSG_BTN_DEL'), key: `DEL_${answer.answerId}` },
                ]"
                @input="onClickTooltip"
              >
                Tooltip Menu
              </sui-tooltip-menu>
              <a class="comment_nick">
                <cmp-user-name-link
                  :pageId="contextPageId"
                  :displayType="'1'"
                  :displayLanguageId="answer.displayLanguageId"
                  :userId="answer.firstRegistrationUserId"
                  :loginId="answer.firstRegistrationLoginId"
                  :userName="answer.userName"
                  :userGlobalName="answer.userGlobalName"
                  :departmentName="answer.departmentName"
                  :departmentEnglishName="answer.departmentEnglishName"
                  :type="'link'"
                />
              </a>
              <!-- 기존 조회 -->
              <textarea
                v-if="answer.editable"
                v-model="answer.answerContent"
              />
              <div
                v-if="answer.answerId!=='' && !answer.editable"
                class="comm_label"
              >
                <span v-if="answer.parentAnswerId!==''" class="author"><strong>RE:</strong> {{ answer.parentRegistrationUserName }}</span>
                {{ answer.answerContent }}
              </div>
              <div
                v-if="answer.answerId!==''"
                class="comment_date"
              >
                {{ answer.firstRegistrationDTM }}
              </div>
              <div class="comment_wrapR">
                <sui-button
                  v-if="answer.answerId!=='' && !answer.editable && answer.deleteYn==='N'"
                  type="button"
                  class="btn_innerTbl_border"
                  @click="onClickReply(answer.answerId, answer.addReplyFlag)"
                >
                  {{ answer.addReplyFlag ? $t('MSG_BTN_CANCEL_COMMENT') : $t('MSG_BTN_COMMENT') }}
                </sui-button>
                <!-- 수정 -->
                <sui-button
                  v-if="answer.answerId!=='' && answer.editable"
                  type="button"
                  class="btn_innerTbl_border"
                  @click="onClickModifyCancelReply(answer.answerId)"
                >
                  {{ $t('MSG_BTN_CANCEL') }}
                </sui-button>
                <sui-button
                  v-if="answer.answerId!=='' && answer.editable"
                  type="button"
                  class="btn_innerTbl_border"
                  @click="modifyReply(answer.answerId, answer.answerContent)"
                >
                  {{ $t('MSG_BTN_RGST') }}
                </sui-button>
              </div>
              <!-- 댓글 클릭 시 -->
              <div
                v-if="answer.addReplyFlag"
                class="mrB10"
              />
              <span
                v-if="answer.addReplyFlag"
                class="ico_reply"
              />
              <div
                v-if="answer.addReplyFlag"
                class="comment_write reply"
              >
                <cmp-user-name-link
                  :pageId="contextPageId"
                  :displayType="'1'"
                  :displayLanguageId="sessionInfo.displayLangId"
                  :userId="sessionInfo.userId"
                  :loginId="sessionInfo.loginId"
                  :userName="sessionInfo.userName"
                  :userGlobalName="sessionInfo.userGlobalName"
                  :departmentName="sessionInfo.departmentName"
                  :departmentEnglishName="sessionInfo.departmentEnglishName"
                  :type="'link'"
                />
                <div class="mrT10" />
                <textarea v-model="answer.childAnswerContent" />
                <div class="comment_wrapR">
                  <sui-button
                    type="button"
                    class="btn_innerTbl_border"
                    @click="registReply(answer.childAnswerContent, answer.answerId)"
                  >
                    {{ $t('MSG_BTN_RGST') }}
                  </sui-button>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="mrB15" />
      <div class="comm_btn_wrap">
        <sui-button
          v-if="isSameAuthorOrBBSADMIN(postUserId)"
          type="button"
          class="comm_btn_border"
          @click="onClickDelete()"
        >
          {{ $t('MSG_BTN_DEL') }}
        </sui-button>
        <sui-button
          v-if="totalModificationPermissionYn === 'Y' || isSameAuthorOrBBSADMIN(postUserId)"
          type="button"
          class="comm_btn_solid"
          @click="onClickModify();"
        >
          {{ $t('MSG_BTN_MDFC') }}
        </sui-button>
        <sui-button
          v-permission:create="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="onScrapClick"
        >
          {{ $t("MSG_BTN_SCRAP") }}
        </sui-button>
        <sui-button
          v-permission:print="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="onPrintClick"
        >
          {{ $t("MSG_BTN_PRTG") }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickCancel()"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
      </div>
    </sui-page-contents>
    <sui-page-footer />
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CLB_00020', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      deleteUserId: '',
      postAnswers: [],
      isBBSAdmin: false,
      attachDocumentId: '',
      bbsId: '',
      postIdParam: '',
      bbsName: '',
      bbsTypeCode: '',
      viewerContents: ' ',
      selectData: {
        label: '',
        key: '',
      },
      frame0: {
        boardTitle: '',
        notice: false,
        editorContent: '',
        firstRegistrationDTM: '',
        qnaNoticeObjSearchedContent: '',
        firstRegistrationUserId: '',
        bbsCategoryItemNm: '',
      },
      applicationUserId: this.$store.getters.userInfo.userName,
      postUserId: '',
      displayLanguageId: '',
      knoxId: '',
      loginId: '',
      userName: '',
      userGlobalName: '',
      departmentName: '',
      departmentEnglishName: '',
      answerDataUpdated: false,
      qnaNoticeObjTextContent: '',
      isWebEdtrInitialized: false,
      sessionInfo: {},
    };
  },
  props: {
    pageInitialData: {
      type: Object,
    },
    closePagePopup: {
      type: Function,
    },
  },
  computed: {},
  watch: {},
  datasets: [],
  beforeMount() {
    this.checkBBSAdminRole();
    this.isCategoryGroupExist = this.pageInitialData.isCategoryGroupExist;
    this.answerUseYn = this.pageInitialData.answerUseYn;
    this.totalModificationPermissionYn = this.pageInitialData.totalModificationPermissionYn;
    this.attachRestrictSize = this.pageInitialData.attachRestrictSize;
    this.tbabRestrictSize = this.pageInitialData.tbabRestrictSize;
    // this.getQNAInfoByPostId();
    this.frame0.boardName = this.pageInitialData.bbsName;
    this.bbsId = this.pageInitialData.bbsId;
    this.postIdParam = this.pageInitialData.postIdParam;
    this.bbsName = this.pageInitialData.bbsName;
    this.bbsTypeCode = this.pageInitialData.bbsTypeCode;
  },
  mounted() {
    this.getQNAInfoByPostId();
  },
  methods: {
    checkBBSAdminRole() {
      this.sessionInfo = this.$store.getters.userInfo;
      const roleListArray = this.sessionInfo.roleList;
      const ifRoleExist = roleListArray.some(
        el => el.roleNickName === 'BBS_ADMIN',
      );
      if (ifRoleExist) {
        this.isBBSAdmin = true;
      }
    },
    isSameAuthorOrBBSADMIN(knoxId) {
      return this.isBBSAdmin || this.$store.getters.userInfo.knoxId === knoxId;
    },
    onClickDelete() {
      utils.messageBox('confirm', this.$t('MSG_ALT_DEL'), null, this.deletePostApi);
    },
    onClickModify() {
      utils.openLayerPopup('PGE_CLB_00022', this.modificationCallback, {
        size: 'xlg',
        pageInitialData: {
          postIdParam: this.pageInitialData.postIdParam,
          bbsId: this.pageInitialData.bbsId,
          bbsName: this.pageInitialData.bbsName,
          isCategoryGroupExist: this.pageInitialData.isCategoryGroupExist,
          attachRestrictSize: this.pageInitialData.attachRestrictSize,
          tbabRestrictSize: this.pageInitialData.tbabRestrictSize,
        },
      });
      this.closePagePopup(false);
    },
    onClickCancel() {
      if (this.answerDataUpdated) {
        this.closePagePopup(true);
      } else {
        this.closePagePopup(false);
      }
    },
    deletePostApi() {
      http.request('PGE_CLB_00020', 'DTS_CLB_00020', {
        path: {
          'post-id': this.pageInitialData.postIdParam,
        },
      }).then(res => {
        if (res.data) {
          utils.messageBox('information', this.$t('MSG_TXT_REG_OK'), null, null);
          this.closePagePopup(true);
          this.updateLogs(this.pageInitialData.postIdParam, 'D');
        }
      }).catch(error => {
        console.log(error);
      });
    },
    modificationCallback(value) {
      if (value) {
        this.closePagePopup(true);
      }
    },
    registReply(answerContent, parentAnswerId) {
      if (!answerContent || answerContent.trim().length === 0) {
        utils.messageBox('warning',
          utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_ANS_CNTN')), null, null);
        return false;
      }
      const dataParams = {
        bbsLogDeptId: this.$store.getters.userInfo.departmentId,
        answerContent: answerContent.substring(0, 3999),
        bbsId: this.pageInitialData.bbsId,
        arraylOrder: this.postAnswers.length,
        parentAnswerId: parentAnswerId || '',
      };
      http.request('PGE_CLB_00020', 'DTS_CLB_00022', {
        path: {
          'post-id': this.pageInitialData.postIdParam,
        },
        data: dataParams,
      }).then(() => {
        this.answerDataUpdated = true;
        this.getRepliesByPostId();
      }).catch(error => {
        console.log(error);
      });
    },
    deleteReplyConfirm(answerId) {
      this.deleteUserId = answerId;
      utils.messageBox('confirm', this.$t('MSG_ALT_DEL'), null, this.deleteReply);
    },
    modifyReply(answerId, answerContent) {
      if (!answerContent || answerContent.trim().length === 0) {
        utils.messageBox('warning',
          utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_ANS_CNTN')), null, null);
        return false;
      }
      const data = {
        answerId: answerId,
        answerContent: answerContent,
        bbsId: this.pageInitialData.bbsId,
        bbsLogDeptId: this.$store.getters.userInfo.departmentId,
      };
      http.request('PGE_CLB_00020', 'DTS_CLB_00062', {
        path: {
          'post-id': this.pageInitialData.postIdParam,
          'answer-id': answerId,
        },
        data: data,
      }).then(() => {
        this.getRepliesByPostId();
        this.updateLogs(this.pageInitialData.postIdParam, 'U', answerId);
      }).catch(error => {
        console.log(error);
      });
    },
    deleteReply() {
      http.request('PGE_CLB_00020', 'DTS_CLB_00063', {
        path: {
          'post-id': this.pageInitialData.postIdParam,
          'answer-id': this.deleteUserId,
        },
      }).then(() => {
        this.answerDataUpdated = true;
        this.getRepliesByPostId();
        this.updateLogs(this.pageInitialData.postIdParam, 'D', this.deleteUserId);
      }).catch(error => {
        console.log(error);
      });
    },
    getRepliesByPostId() {
      http.request('PGE_CLB_00020', 'DTS_CLB_00021', {
        path: {
          'post-id': this.pageInitialData.postIdParam,
        },
      }).then(res => {
        let data = res.data;
        data.forEach(element => {
          element.firstRegistrationDTM = utils.toStringByFormat(
            element.firstRegistrationDTM,
            'YYYY-MM-DD HH:mm:ss',
          );
          element.parentAnswerId = utils.isEmpty(utils.trim(element.parentAnswerId)) ? '' : element.parentAnswerId;
          element.editable = false;
          element.originAnswerContent = element.answerContent;
          element.addReplyFlag = false;
          element.childAnswerContent = '';
        });
        if (!(res.data.length >= 99999998)) {
          const newRecord = {
            answerId: '',
            userName: this.$store.getters.userInfo.userName,
            answerContent: '',
            firstRegistrationDTM: moment().format('YYYY-MM-DD HH:mm:ss'),
            displayLanguageId: this.$store.getters.userInfo.displayLangId,
            knoxId: this.$store.getters.userInfo.knoxId,
            loginId: this.$store.getters.userInfo.loginId,
            userGlobalName: this.$store.getters.userInfo.userGlobalName,
            departmentName: this.$store.getters.userInfo.departmentName,
            bbsLogDeptId: this.$store.getters.userInfo.departmentId,
            firstRegistrationUserId: this.$store.getters.userInfo.userId,
            departmentEnglishName: this.$store.getters.userInfo.departmentEnglishName,
            editable: true,
            originAnswerContent: '',
            addReplyFlag: false,
            childAnswerContent: '',
            parentAnswerId: '',
            parentRegistrationUserName: '',
          };
          data.unshift(newRecord);
          this.postAnswers = utils.cloneDeep(data);
        }
      }).catch(error => {
        console.log(error);
      });
    },
    // Reset attachment
    onResetFileAttacher() {
      this.$refs.fileAttacher.reset();
    },
    getFileListInfo() {
      this.fileList = this.$refs.fileAttacher.getAttachGroupItemListInfo();
    },
    getQNAInfoByPostId() {
      http.request('PGE_CLB_00020', 'DTS_CLB_00018', {
        path: {
          'post-id': this.pageInitialData.postIdParam,
        },
      }).then(res => {
        if (res.data) {
          this.selectData = {
            label: res.data[0].bbsCategoryItemNm,
            key: res.data[0].bbsCategoryItemId,
          };
          this.frame0.boardTitle = res.data[0].qnaNoticeObjTextTitle;
          this.qnaNoticeObjTextContent = res.data[0].qnaNoticeObjTextContent;
          this.$refs.myEditor.setHtml(this.qnaNoticeObjTextContent);
          this.isWebEdtrInitialized = true;
          this.postUserId = res.data[0].knoxId;
          if (
            res.data[0].attachFileList
            && res.data[0].attachFileList.length > 0
          ) {
            this.attachDocumentId = res.data[0].attachFileList[0].attachDocumentId;
          }
          this.frame0.firstRegistrationDTM = utils.toStringByFormat(
            res.data[0].firstRegistrationDTM,
            'YYYY-MM-DD HH:mm:ss',
          );
          this.frame0.qnaNoticeObjSearchedContent = res.data[0].qnaNoticeObjSearchedContent;
          this.frame0.firstRegistrationUserId = res.data[0].firstRegistrationUserId;
          this.frame0.bbsCategoryItemNm = res.data[0].bbsCategoryItemNm;
          this.displayLanguageId = res.data[0].displayLanguageId;
          this.knoxId = res.data[0].knoxId;
          this.loginId = res.data[0].loginId;
          this.userName = res.data[0].userName;
          this.userGlobalName = res.data[0].userGlobalName;
          this.departmentName = res.data[0].departmentName;
          this.departmentEnglishName = res.data[0].departmentEnglishName;
        }
        this.getRepliesByPostId();
      });
    },
    updateLogs(postId, type, answerId) {
      const pathParam = {
        'post-id': answerId ? answerId : postId,
      };
      http.request('PGE_CLB_00020', 'DTS_CLB_00061', {
        path: pathParam,
        data: {
          bbsLogTypeCd: type,
          bbsId: this.pageInitialData.bbsId,
          bbsLogDeptId: this.$store.getters.userInfo.departmentId,
        },
      }).then(() => {});
    },
    editorInitCallback() {
      this.$refs.myEditor.setHtml(this.qnaNoticeObjTextContent);
    },
    onClickTooltip(key) {
      const strArr = utils.split(key, '_');
      const action = strArr[0];
      const selectedAnswerId = strArr[1];
      if (action === 'MOD') {
        const idx = utils.findIndex(this.postAnswers, { answerId: selectedAnswerId });
        if (idx >= 0) {
          this.postAnswers[idx].editable = true;
        }
      } else { // action === 'DEL'
        this.deleteReplyConfirm(selectedAnswerId);
      }
    },
    onClickModifyCancelReply(selectedAnswerId) {
      const idx = utils.findIndex(this.postAnswers, { answerId: selectedAnswerId });
      if (idx >= 0) {
        this.postAnswers[idx].editable = false;
        this.postAnswers[idx].answerContent = this.postAnswers[idx].originAnswerContent;
      }
    },
    onClickReply(selectedAnswerId, addReplyFlag) {
      const idx = utils.findIndex(this.postAnswers, { answerId: selectedAnswerId });
      if (idx >= 0) {
        this.postAnswers[idx].addReplyFlag = !addReplyFlag;
        this.postAnswers[idx].childAnswerContent = '';
      }
    },
    onPrintClick() {
      this.openPrintWindow('PGE_CLB_00031', 'bbsId', this.bbsId);
    },
    openPrintWindow(pageId, key, value) {
      const queryString = `?${key}=${value}&postIdParam=${this.postIdParam}&bbsName=${this.bbsName}&bbsTypeCode=${this.bbsTypeCode}`;

      utils.openWindowPopup(pageId, queryString, null, {
        top: 100, left: 300, height: 700, width: 915,
      });
    },
    onScrapClick() {
      const dataParams = {
        postUID: this.postIdParam,
        bbsId: this.bbsId,
        bbsTypeCode: this.bbsTypeCode,
        usrId: this.$store.getters.userInfo.userId,
      };

      utils.messageBox('confirm', this.$t('MSG_ALT_SCRAP'), null, () => {
        http.request(this.contextPageId, 'DTS_CLB_00065', {
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_SCRAP'));
        });
      });
    },
  },
};
</script>
<style scoped>
</style>
